'use strict';/* global define */define('modules/feedback/states/admin_feedback-periods/controller',['require','exports','module'],function(require,exports,module){'use strict';// @ngInject
     controller.$inject = ["$scope", "$rootScope", "$state"];
function controller($scope,$rootScope,$state){// jshint validthis:true
// jshint latedef:false
var ctrl=this;ctrl.currentState=$state.current;ctrl.periodStates=_getEnhancedPeriodStates(ctrl.currentState);var cleanAdminFeedbackState=$rootScope.$on('$stateChangeSuccess',function(event,toState){ctrl.currentState=toState;});$scope.$on('$destroy',cleanAdminFeedbackState);// ---
/**
     * Get period states
     *
     * @param  {Object} currentState - Selected state
     * @return {Array}               - List of states
     */function getPeriodStates(currentState){var parentStateName=getParentStateName(currentState);var parentStateRegex=new RegExp('^'+parentStateName+'\\..+?$');return $state.get().filter(function(state){return parentStateRegex.test(state.name);});}/**
     * Get name of the parent state
     *
     * @param  {Object} state - State object
     * @return {String}       - Parent state name
     */function getParentStateName(state){var parentStateSplit=state.name.split('.');parentStateSplit.pop();return parentStateSplit.join('.');}/**
     * Helper method to add the translation id to the state objects
     *
     * @param  {Object} currentState - Current state object
     * @return {Array}               - List of state objects
     */function _getEnhancedPeriodStates(currentState){var periodStates=getPeriodStates(currentState);return periodStates.map(function(periodState){periodState.translationId=periodState.name.split('.')[3].toUpperCase();return periodState;});}}module.exports=controller;});
